<template>
  <div class="news">
    <top-nav ref="TopNav"></top-nav>
    <van-nav-bar :title="datas.title" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div class="van-content">
      <div class="newsbox">
        <div v-html="datas.content"></div>
        <div class="time">{{ datas.add_time }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "mynews",
    components: {
      TopNav
    },
    data () {
      return {
        datas:[],
        id:this.$route.query.id,
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas: function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        this.page++
        this.$api.post('WebApi/Message/Index/preview', {token:isUser,id:this.id}, res => {
          this.datas = res.data.data
        })
      },
    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
  .news{
    min-height: 100vh;
    padding: 15px;
    box-sizing: border-box;
    .time{
      text-align: right;
      margin-top: 20px;
    }
    .van-content{
      .newsbox{
        background: #fff;
        border-radius: 6px;
        padding: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/mynews/news.vue